import { assimagraLogo, footerSustainableStone, footerPRR, footerPortugueseRepublic, footerUE } from "@/assets";

export const Footer = () => {
  return (
    <footer className="py-4 mt-auto bg-white w-full flex-shrink-0 border-t border-gray-100">
      <div className="px-8 flex justify-center overflow-x-auto">
        <div className="flex items-center gap-8 flex-nowrap min-w-0">
          <img src={assimagraLogo} alt="ASSIMAGRA" className="h-9 w-auto" />
          <img src={footerSustainableStone} alt="Sustainable Stone" className="h-12 w-auto" />
          <img src={footerPRR} alt="PRR" className="h-12 w-auto" />
          <img src={footerPortugueseRepublic} alt="República Portuguesa" className="h-12 w-auto" />
          <img src={footerUE} alt="União Europeia" className="h-12 w-auto" />
        </div>
      </div>
    </footer>
  );
};
